import React, { Component } from 'react';
import moment from 'moment'
import { firebaseRef } from 'config'
import ReactDisqusThread from 'react-disqus-thread'

export default class FeatureBoard extends Component {
  constructor(props) {
    super(props)
    this.onVote = this.onVote.bind(this)
    this.state = {
      comments: null
    }
  }

  onVote(feature) {
    let update = true
    if (!!feature.votes[this.props.userId])
      update = null
    firebaseRef.child('featureboard')
      .child(feature._id)
      .child('votes')
      .child(this.props.userId)
      .set(update)
  }

  getRightContent(feature) {
    if (feature.finished)
      return (
        <div>
          { Object.keys(feature.votes).length }
          <i className='fa fa-check fa-fw text-success'></i>
        </div>
      )
    return (
      <div>
        { Object.keys(feature.votes).length }
        <i
          className={'ionicons ion-ios-heart vote' + (!!feature.votes[this.props.userId] ? ' voted' : '' )}
          onClick={() => this.onVote(feature)}>
        </i>
      </div>
    )
  }

  toggleComments(id) {
    if (this.state.comments === id) {
      this.setState({
        comments: null
      })
    } else {
      this.setState({
        comments: id
      })
    }
  }

  render() {
    return (
        <div className='list-group feature-group'>
        { this.props.features.map(feature => (
            <div className={ 'list-group-item' + (feature.finished ? ' finished' : '') } key={feature._id}>
              <div className='row'>
                <div className='col-xs-10'>
                  <div className='col-xs-12 title'>
                    { feature.title }
                  </div>
                  <div className='col-xs-12 description'>
                    { feature.description }
                  </div>
                  <div className='col-xs-12 author text-muted'>
                    Submitted by { feature.author.name } @ { moment(feature.createdAt).format('MMM Do')}
                  </div>
                </div>
                <div className='col-xs-2 votes'>
                  { this.getRightContent(feature) }
                </div>
                { !feature.finished &&
                  <button className='pull-right btn btn-primary' onClick={() => this.toggleComments(feature._id) }>
                    { this.state.comments === feature._id ? 'Hide comments' : 'View comments' }
                  </button>
                }
              </div>
              { this.state.comments === feature._id && (
                <ReactDisqusThread
                  shortname={'edgebet-feature-board'}
                  identifier={feature._id}
                  title={feature.title}
                />)
              }
            </div>
          )
        )}
      </div>
    )
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/featureboard/FeatureBoard.js
 **/